import {
    TopBetsMatchListActions,
    TopBetsMatchListSetFilterDataAction,
    TopBetsMatchListSetLoadingData,
    TopBetsMatchListStoreModel,
} from './top-bets-list.constants';
import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction } from '@om-fe/store';
import { filterItemsSelectorFromRecords } from '../../../match-list/utils/filter-items-from-records';
import applyUpdatesForMatchList from '../../../match-list/utils/apply-updates-for-match-list';
import { getTopBetsMatchListSliceName } from './top-bets-list.utils';
import { AggregatorOneOfTypeModel } from '@om-fe/models';
import { UpdateAction } from '@om-fe/api';
import { isBrowser } from '@om-fe/utils';
import { getNextMatchListTotalRecords, getPopularMatchListTotalRecords } from '../../../match-list/utils/match-list-limit';

const initialState: TopBetsMatchListStoreModel = {
    fetchedFromBrowser: isBrowser(),
    ready: false,
    limit: 0,
    totalRecords: 0,
    isLoadingMoreData: false,
    isLoadingData: true,
    discipline: undefined,
    filteredEventInfos: {},
    filteredMainMarketsList: [],
    filteredMainMarkets: {},
    filteredMarketGroupsOverviewList: [],
    filteredMarketGroupsOverview: {},
    filteredEventStatistics: [],
    filteredMarketAndOutcomeRelation: {},
    filteredOutcomes: {},
    filteredBettingOffers: {},
    filteredMatchesWithEvents: {},
    filteredMatchesIds: [],
    marketsWithOutcomesAndBettingOffers: {},
    filteredStreamingProviderEventRelation: {},
    marketGroupsOverviewIds: '',
    timeRange: '',
    locationId: undefined,
    categoryId: undefined,
    isTopBets: true,
    isCategory: false,
    isAuthenForTopic: false,
    filteredMainOutrightsMarketsList: [],
};

export const topBetsMatchListGroupsOverviewReducerCreator = (instanceId: string) => (
    state: TopBetsMatchListStoreModel = initialState,
    action: AppAction,
): TopBetsMatchListStoreModel => {
    const slice: string = getTopBetsMatchListSliceName(instanceId);

    const { meta } = action;

    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {
        case TopBetsMatchListActions.SetLoadingData: {
            const { payload: { isLoadingMoreData } } = action as TopBetsMatchListSetLoadingData;

            return {
                ...state,
                isLoadingData: !isLoadingMoreData,
                isLoadingMoreData,
            };
        }
        case TopBetsMatchListActions.SetFilterData: {
            const { payload } = action as TopBetsMatchListSetFilterDataAction;

            return {
                ...state,
                timeRange: payload.timeRange,
                limit: payload.limit,
                disciplineId: payload.disciplineId,
                marketGroupsOverviewIds: payload.marketGroupsOverviewIds,
                isTopBets: payload.isTopBets,
                locationId: payload.locationId,
                categoryId: payload.categoryId,
                isCategory: payload.isCategory,
                timeRangeType: payload.timeRangeType,
                timeRangeValue: payload.timeRangeValue,
                isAuthenForTopic: payload.isAuthenForTopic,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;
            const { isTopBets, locationId } = state;
            const records: AggregatorOneOfTypeModel[] = payload.records;
            const totalRecords: number = isTopBets || locationId === '0' ? getPopularMatchListTotalRecords(records) : getNextMatchListTotalRecords(records);

            return {
                ...state,
                ...filterItemsSelectorFromRecords(records),
                fetchedFromBrowser: isBrowser(),
                totalRecords,
                ready: true,
                isLoadingData: false,
                isLoadingMoreData: false,
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;
            const { isTopBets } = state;
            const totalRecords: number = isTopBets ? getPopularMatchListTotalRecords(payload.records) : getNextMatchListTotalRecords(payload.records);

            return {
                ...state,
                ...applyUpdatesForMatchList(payload, state),
                totalRecords,
                isLoadingMoreData: false,
            };
        }
        default:
            return state;
    }
};